/********************************* Utility Functions *********************/

// convert string of date to human-readable format
function dateToString(dateString) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [year, month, day] = dateString.split('-');
    const date = new Date(Date.UTC(year, month - 1, day));
    return `${months[date.getUTCMonth()]} ${date.getUTCDate()} ${date.getUTCFullYear()}`;
}

// push date object X days
function pushDate(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate.toISOString().split('T')[0];
}

// logout function
function logout() {
    localStorage.removeItem("recharge_session");
    window.location.href = "/account/logout?return_url=%2Faccount%2Flogin";
}

// function to take mongodb utc to MM/DD/YYYY
function mongoDateToHuman(date) {
    return new Date(parseInt(date["$date"]["$numberLong"])).toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

// refresh subscription pricing
async function refreshSubscriptionPrice(subscriptionID) {
    await fetch(`${root}/portal/refresh-subscription-price.php`, {
        method: "POST",
        body: new URLSearchParams({
            subscriptionID: subscriptionID
        })
    });
    return true;
}

// refresh onetime pricing
async function refreshOnetimePrice(onetimeID) {
    await fetch(`${root}/portal/refresh-onetime-price.php`, {
        method: "POST",
        body: new URLSearchParams({
            onetimeID: onetimeID
        })
    });
    return true;
}


// error function
async function logError(error) {
    await fetch(`${root}/portal/error.php`, {
        method: "POST",
        body: new URLSearchParams({
            error: error
        })
    });
}

// refresh global variables
async function refreshGlobalVariables() {
    await Promise.all([
        recharge.subscription.listSubscriptions(session, {
            limit: 25,
            sort_by: 'id-desc',
        }),
        recharge.address.listAddresses(session),
        recharge.paymentMethod.listPaymentMethods(session),
        recharge.onetime.listOnetimes(session),
    ])
        .then(response => {
            subscriptions = response[0].subscriptions;
            addresses = response[1].addresses;
            paymentMethods = response[2].payment_methods;
            onetimes = response[3].onetimes
        });

    upgradePendingList = await fetch(`${root}/portal/upgrade/get-pending.php`, {
        method: "POST",
        body: JSON.stringify({
            shopify_customer_id: shopifyCustomerID
        })
    })
        .then(response => response.json());
}

async function toggleStyling() {
    try {
        let location = await retrieveLocation();
        if (location.region?.toLowerCase().includes('california')) {
            // hide the underline styled button, show the new styled button
            document.querySelector('.portalAccountCancel.portalButton')?.classList.add('active');
            document.querySelector('.portalAccountCancel.underline')?.classList.remove('active');
        }
    } catch (error) {
        console.error("Error retrieving location", error);
    }
}

toggleStyling();


/*************************** Global Variables ***************************/

// get url params
const urlParams = new URLSearchParams(window.location.search);

// us variant ids
const rollsVariantsUS = [handleToVariantID["16-rolls"], handleToVariantID["32-rolls"], handleToVariantID["96-rolls"]];
const bundlesVariantsUS = [handleToVariantID["16-rolls-4-boxes"], handleToVariantID["32-rolls-8-boxes"]];
const tissueVariantUS = handleToVariantID["12-boxes"];

// ca variant ids
const rollsVariantsCA = [handleToVariantID["16-rolls-ca"], handleToVariantID["32-rolls-ca"], handleToVariantID["96-rolls-ca"]];
const bundlesVariantsCA = [handleToVariantID["16-rolls-4-boxes-ca"], handleToVariantID["32-rolls-8-boxes-ca"]];
const tissueVariantCA = handleToVariantID["12-boxes-ca"];

// cadence options
const cadences = [4, 6, 9, 12, 16, 18, 24];

// banned states
const bannedProvinces = [
    "alaska",
    "american samoa",
    "micronesia",
    "guam",
    "hawaii",
    "marshall islands",
    "northern mariana islands",
    "palau",
    "puerto rico",
    "virgin islands",
    "armed forces"
];

// discount code for upgrades
const discountCode = "TRYTISSUES";

/******************************** Reactivate Subscription *********************/

// General Reactivate Flow - https://plantpaper.us/account/?reactivate=true
// 10% Reactivate Flow - https://plantpaper.us/account/?reactivate=10

// check for reactivate query string
if (urlParams.get("reactivate")) {
    sessionStorage.setItem("reactivate", urlParams.get("reactivate"));
    window.history.replaceState({}, document.title, window.location.pathname);
}

/******************** Check for back button *****************/

if (performance.navigation.type === 2) {
    window.location.reload();
    throw new Error("Refreshing due to back button");
}

/******************** Recharge Setup / Variables ********************/

// start recharge
recharge.init({
    storefrontAccessToken: 'strfnt_383881b23003928358e7be0dad07b9118f2a096156434597cb023f03011c1938',
});

// recharge auth object
let session;

/****************************** Portal Start ********************/

// setup portal
let shopifyCustomerID, customer, subscriptions, addresses, paymentMethods, onetimes, upgradeJustCompleted,
    upgradePendingList;

async function setupPortal() {
    // determine if we're in via shopify or localstorage
    if (["/pages/subscription-portal", "/pages/subscription-portal/"].includes(window.location.pathname)) {
        session = JSON.parse(localStorage.getItem("recharge_session"));
    } else if (["/account", "/account/", "/account.ogin"].includes(window.location.pathname)) {
        session = await recharge.auth.loginShopifyAppProxy();
    } else {
        // generic error
        await Swal.fire({
            icon: "warning",
            title: "It doesn't look like you're logged in. Let's try again.",
        });
        logout();
        return;
    }

    // get customer
    try {
        customer = await recharge.customer.getCustomer(session);
    } catch (e) {
        console.log(e);

        // GA4 errors
        gtag('event', 'portal_error_login_customer');

        // check for not logged in
        if (e.message === "Not logged in.") {
            await Swal.fire({
                icon: "warning",
                title: "This email is not associated with any current or past subscription.",
                html: `Please click <a href="/pages/plant-paper"><u>here</u></a> to set up a new subscription.`
            });
        } else {
            await Swal.fire({
                icon: "warning",
                title: "We're having an issue accessing your account.",
                text: "Please refresh and try again otherwise contact info@plantpaper.us with error code P1."
            });
        }

        logout();
        return;
    }

    // get shopify customer ids
    shopifyCustomerID = parseInt(customer.external_customer_id.ecommerce);

    // get addresses, subscriptions and payment methods
    try {
        await refreshGlobalVariables();
    } catch (e) {
        console.log(e);

        // GA4 errors
        gtag('event', 'portal_error_login');

        // generic error
        await Swal.fire({
            icon: "warning",
            title: "We're having an issue accessing your account.",
            text: "Please refresh and try again otherwise contact info@plantpaper.us with error code P1."
        });

        logout();
        return;
    }

    // GA4 login
    gtag('event', 'portal_login');

    // save user to clarity
    try {
        window.clarity("identify", customer.email);
    } catch (e) {
        console.warn("Clarity not loaded yet.");
    }

    try {
        // identify
        klaviyo.identify({
            '$email': customer.email,
        })
            .then(() => {
                // track
                klaviyo.push(["track", "Portal Login | MalterTech"]);
            });
    } catch (e) {
        // do nothing
    }

    // setup intro
    document.querySelector("#introName").textContent = `Welcome ${customer.first_name ?? ""},`;

    // setup intro close
    document.querySelector("#introAnnouncementClose").addEventListener("click", function () {
        document.querySelector("#introAnnouncement").classList.remove("active");
        document.querySelector("#introOpen").classList.add("active");
    });

    // setup intro open
    document.querySelector("#introOpen").addEventListener("click", function () {
        document.querySelector("#introAnnouncement").classList.add("active");
        document.querySelector("#introOpen").classList.remove("active");
    });

    // get tiers
    let tiers = await fetch(`${root}/portal/get-tiers.php`, {
        method: "POST",
        body: JSON.stringify({
            shopify_customer_id: shopifyCustomerID
        })
    })
        .then(response => response.json());

    // loop over each tier and multiply by 100 so it works with our price function
    for (const variantID in tiers) {
        tiers[variantID] *= 100;
    }

    // determine if they have done a tissue upsell discount before
    let isUpgradeDiscountEligible = await fetch(`${root}/portal/upgrade/is-discount-eligible.php`, {
        method: "POST",
        body: JSON.stringify({
            shopify_customer_id: shopifyCustomerID
        })
    })
        .then(response => response.json())
    isUpgradeDiscountEligible = isUpgradeDiscountEligible.is_eligible;

    // determine if the customer has any bundles or 12 packs
    let hasTissues = false;
    subscriptions.forEach(sub => {
        // find product in our matrix
        let product = products[sub.external_variant_id.ecommerce];

        // subscription must be acitive, skip if not
        if (sub.status !== "active") return;

        // check if this is a bundle or 12 pack
        if (bundlesVariantsUS.includes(product.variant_id) || bundlesVariantsCA.includes(product.variant_id) || product.variant_id === tissueVariantUS || product.variant_id === tissueVariantCA) {
            hasTissues = true;
        }
    });

    // determine if they have any active subscriptions
    let hasActiveSubscription = subscriptions.some(sub => sub.status === "active");

    // if eligible for discount AND doesn't have any pending upgrades AND doesn't have any tissues
    if (isUpgradeDiscountEligible && upgradePendingList.length === 0 && hasTissues === false && onetimes.length === 0 && hasActiveSubscription === true) {
        // update prompt in announcement bar
        document.querySelector("#introAnnouncementBody").innerHTML = `
            <b>Try facial tissues and save $10</b><br>
            We’ve made it easier than ever to try facial tissues—no subscription necessary. Click <a href="#"><u>here</u></a> to save $10!
        `;

        // add event listener to scroll down
        document.querySelector("#introAnnouncementBody a").addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector(".portalSubscriptionsGridItemUpgrade").scrollIntoView({behavior: 'smooth'});
        });
    }

    // discount value
    const firstTimeUpgradeDiscountAmount = 1000; // $10.00

    // add customer id for css overrides
    document.querySelector("#portal").setAttribute("data-recharge-customer-id", customer.id);

    // append list of subscriptions to intro header
    subscriptions.forEach((subscription) => {
        // function to render subscription
        async function renderSubscription(target = null, refreshData = false, updated = []) {
            // check if we need to refresh data
            if (refreshData) {
                await refreshGlobalVariables();

                // update the subscription from the refreshed data so it's in sync
                subscription = subscriptions.find(sub => sub.id === subscription.id);
            }

            // find the corresponding address for this subscription
            let address = addresses.filter(address => address.id === subscription.address_id)[0];

            // find the payment method id
            let paymentMethod = paymentMethods.filter(payment_method => payment_method.id === address.payment_method_id)[0];

            // check if no payment method
            if (!paymentMethod) {
                const customerPortalAccess = await recharge.customer.getCustomerPortalAccess(session);

                // only show popup if subscription is active
                if (subscription.status === "active") {
                    // fire swal with instructions to update payment method
                    await Swal.fire({
                        html: `
                            <div id="swalPaymentMethodNotFound">
                                Hi Planter! 🌱
                                <br><br>
                                It looks like there's an issue with your payment method on your subscription for ${subscription.product_title}. To keep receiving your PlantPaper, please update your payment method below.
                                <br><br>
                                <a class="button" href="https://plantpaper.us/tools/recurring/portal/${customerPortalAccess.customer_hash}/payment_methods?token=${customerPortalAccess.temp_token}" target="_blank">Update Payment Method</a>
                            </div>
                        `,
                        showConfirmButton: false
                    });
                }
                return;
            }

            // find product in our matrix
            let product = products[subscription.external_variant_id.ecommerce];

            // parse their price
            let currentSubscriptionPrice = parseFloat(subscription.price) * 100;

            // if the customer has any bundles or 12 packs, we exit
            let hasTissues = false;
            subscriptions.forEach(sub => {
                // find product in our matrix
                let product = products[sub.external_variant_id.ecommerce];

                // subscription must be acitive, skip if not
                if (sub.status !== "active") return;

                // check if this is a bundle or 12 pack
                if (bundlesVariantsUS.includes(product.variant_id) || bundlesVariantsCA.includes(product.variant_id) || product.variant_id === tissueVariantUS || product.variant_id === tissueVariantCA) {
                    hasTissues = true;
                }
            });

            // check if this subscription has a pending upgrade
            const upgradePending = upgradePendingList.find(upgrade => upgrade.subscription_id === subscription.id);

            // check if upgrade has been swapped but NOT completed (limbo period, prevent changes)
            const upgradeLimbo = upgradePending && upgradePending.swapped_at !== null;

            // get onetime order matching this address
            let onetime;
            onetimes.forEach(otp => {
                if (otp.properties && otp.properties[0] && parseInt(otp.properties[0].value) === subscription.id) {
                    onetime = otp;
                }
            });

            // function to plan HTML
            function planHTML() {
                // function to generate option HTML based on the variant
                function optionHTML(variantID) {
                    // get the price using their tiers
                    let tierPrice = price(tiers[variantID]);

                    // check if this option is the current subscription
                    let isActiveProduct = variantID === product.variant_id;

                    // return HTML
                    return `
                        <option value="${variantID}" ${isActiveProduct ? "selected" : ""}>
                            ${products[variantID].modify_title} (${tierPrice})
                        </option>
                    `;
                }

                // html string
                let HTML = "";

                // check for USA plan
                if (rollsVariantsUS.includes(product.variant_id) || bundlesVariantsUS.includes(product.variant_id)) {
                    // add base plans and select their current variant
                    rollsVariantsUS.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });

                    // add add-ons and select their current variant
                    HTML += `<optgroup label="Tissue bundles:">`;
                    bundlesVariantsUS.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });
                    HTML += `</optgroup>`;
                }
                // check for CA plan
                else if (rollsVariantsCA.includes(product.variant_id) || bundlesVariantsCA.includes(product.variant_id)) {
                    rollsVariantsCA.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });

                    // add add-ons and select their current variant
                    HTML += `<optgroup label="Tissue bundles:">`;
                    bundlesVariantsCA.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });
                    HTML += `</optgroup>`;
                }
                // return their current variant
                else {
                    HTML += `<option value="${product.variant_id}">${product.modify_title} (${price(currentSubscriptionPrice)})</option>`;
                }

                return HTML;
            }

            // function for cadence html
            function cadenceHTML() {
                let HTML = "";

                // check if we have a custom cadence
                if (!cadences.includes(subscription.order_interval_frequency)) {
                    HTML += `<option value="${subscription.order_interval_frequency}" selected>Every ${subscription.order_interval_frequency} ${subscription.order_interval_unit}</option>`;
                }

                // generate HTML
                cadences.forEach(cadence => {
                    HTML += `<option value="${cadence}" ${cadence === subscription.order_interval_frequency ? "selected" : ""}>Every ${cadence} weeks</option>`;
                });

                return HTML;
            }

            // function for next delivery date html
            function nextDeliveryDateHTML() {
                // active subscription with no next charge date means the payment method faild
                if (subscription.status === "active" && subscription.next_charge_scheduled_at) {
                    return dateToString(subscription.next_charge_scheduled_at);
                } else if (subscription.status === "active") {
                    return "Payment Failed"
                } else {
                    return "N/A";
                }
            }

            // address html
            function addressHTML() {
                let HTML = "";

                // loop through addresses
                addresses.forEach(address => {
                    HTML += `<option value="${address.id}" ${address.id === subscription.address_id ? "selected" : ""}>${address.address1}</option>`;
                });

                return HTML;
            }

            // upgrade html
            function upgradeHTML() {
                // if not active, exit, we do not want to show upgrade widget on cnacel subscriptions
                if (subscription.status !== "active") {
                    return "";
                }

                // exit if they have an upcoming upgrade
                if (upgradePending) {
                    return "";
                }

                // exit if they have an active one-time order
                if (onetime) {
                    return "";
                }

                // if they have any active tissue subscriptions, we exit
                if (hasTissues) {
                    return "";
                }

                // create an array of eligible items
                let upgradeEligibleItems = [];

                // split based on currency
                if (subscription.presentment_currency === "USD") {
                    // 16+4 and 32+8 require a matching rolls product
                    if (product.handle === "16-rolls") {
                        upgradeEligibleItems.push({
                            title: "4 boxes of tissue (bundled)",
                            product: products[handleToVariantID["16-rolls-4-boxes"]],
                            is_bundle: true
                        });
                    } else if (product.handle === "32-rolls") {
                        upgradeEligibleItems.push({
                            title: "8 boxes of tissue (bundled)",
                            product: products[handleToVariantID["32-rolls-8-boxes"]],
                            is_bundle: true
                        });
                    }

                    // add the 12 boxes of tissue for all rolls
                    if (product.handle === "16-rolls" || product.handle === "32-rolls" || product.handle === "96-rolls") {
                        upgradeEligibleItems.push({
                            title: "12 boxes of tissue",
                            product: products[handleToVariantID["12-boxes"]],
                            is_bundle: false
                        });
                    }
                } else {
                    // 16+4 and 32+8 require a matching rolls product
                    if (product.handle === "16-rolls-ca") {
                        upgradeEligibleItems.push({
                            title: "4 boxes of tissue (bundled)",
                            product: products[handleToVariantID["16-rolls-4-boxes-ca"]],
                            is_bundle: true
                        });
                    } else if (product.handle === "32-rolls-ca") {
                        upgradeEligibleItems.push({
                            title: "8 boxes of tissue (bundled)",
                            product: products[handleToVariantID["32-rolls-8-boxes-ca"]],
                            is_bundle: true
                        });
                    }

                    // add the 12 boxes of tissue for all rolls
                    if (product.handle === "16-rolls-ca" || product.handle === "32-rolls-ca" || product.handle === "96-rolls-ca") {
                        upgradeEligibleItems.push({
                            title: "12 boxes of tissue",
                            product: products[handleToVariantID["12-boxes-ca"]],
                            is_bundle: false
                        });
                    }
                }

                // if upgradeEligibleItems is empty, return empty string
                if (upgradeEligibleItems.length === 0) {
                    return "";
                }

                // determine title
                let upgradeTitle = `Add PlantPaper facial<br> tissue to your next order.`;
                if (isUpgradeDiscountEligible === true) {
                    upgradeTitle = `Try PlantPaper facial<br> tissue in your next order<br> for ${price(firstTimeUpgradeDiscountAmount)} off.`;
                }

                // loop over eligible items and create HTML
                let upgradeEligibleHTML = "";
                upgradeEligibleItems.forEach(item => {
                    // determine price (new price minus current subscription price for non-bundles)
                    let upgradePrice = tiers[item.product.variant_id];
                    if (item.is_bundle) {
                        upgradePrice = tiers[item.product.variant_id] - currentSubscriptionPrice;
                    }

                    // determine info message
                    let info = "(ships as part of a bundle with your next subscription order)";
                    if (!item.is_bundle) {
                        info = "(can ship separate from your subscription order)";
                    }

                    // append html (note, we preselect if only 1 option)
                    upgradeEligibleHTML += `
                        <label class="portalSubscriptionsGridItemUpgradePackListItem">
                            <input class="portalSubscriptionsGridItemUpgradePackListItemRadio" type="radio" name="tissue_size" data-product="${item.product.id}" data-variant="${item.product.variant_id}" ${upgradeEligibleItems.length === 1 ? "checked" : ""}>
                            <div class="portalSubscriptionsGridItemUpgradePackListItemContent">
                                <div class="portalSubscriptionsGridItemUpgradePackListItemContentHeader">
                                    <div class="portalSubscriptionsGridItemUpgradePackListItemContentHeaderTitle">${item.title}</div>
                                    <div class="portalSubscriptionsGridItemUpgradePackListItemContentHeaderPrice">${isUpgradeDiscountEligible ? `<s>${price(upgradePrice)}</s> ${price(upgradePrice - firstTimeUpgradeDiscountAmount)}` : `${price(upgradePrice)}`}</div>
                                </div>
                                <div class="portalSubscriptionsGridItemUpgradePackListItemContentInfo">${info}</div>
                            </div>
                        </label>
                    `;
                });

                // if there is only 1 option, switch to add to cart (96 + 12)
                let upgradeEligiblePackNextButton = "Next";

                // create cancel html
                const backHTML = `
                    <a class="portalSubscriptionsGridItemUpgradePageBack" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                            <path d="M0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM12 4V3.5L1 3.5V4V4.5L12 4.5V4Z" fill="black"/>
                        </svg>
                        Back
                    </a>
                `;

                return `
                    <div class="portalSubscriptionsGridItemUpgrade">
                        <div class="portalSubscriptionsGridItemUpgradeStart portalSubscriptionsGridItemUpgradePage active">
                            <div class="portalSubscriptionsGridItemUpgradeStartTitle">${upgradeTitle}</div>
                            <div class="portalSubscriptionsGridItemUpgradeStartGrid">
                                <img class="portalSubscriptionsGridItemUpgradeStartGridImage" src="https://plantpaper.us/cdn/shop/t/91/assets/portal-tissues.jpg">
                                <div class="portalSubscriptionsGridItemUpgradeStartGridContent">
                                    <div class="portalSubscriptionsGridItemUpgradeStartGridContentTitle">PlantPaper toxin-free facial tissue</div>
                                    <ul class="portalSubscriptionsGridItemUpgradeStartGridContentList">
                                        <li>Super soft, strong 3-ply, FSC© certified bamboo</li>
                                        <li>100% free of PFAS, bleach, formaldehyde and irritants</li>
                                        <li>No dyes, fragrances, or lotions</li>
                                    </ul>
                                </div>
                            </div>
                            <button class="portalSubscriptionsGridItemUpgradeStartButton">Get Facial Tissue</button>
                        </div>
                        <div class="portalSubscriptionsGridItemUpgradeType portalSubscriptionsGridItemUpgradePage">
                            <div class="portalSubscriptionsGridItemUpgradeTypeTitle">Would you like to<br> subscribe or purchase<br> one-time?</div>
                            <button class="portalSubscriptionsGridItemUpgradeTypeSub">Subscribe</button>
                            <button class="portalSubscriptionsGridItemUpgradeTypeOTP">One-time purchase</button>
                            ${backHTML}
                        </div>
                        <div class="portalSubscriptionsGridItemUpgradePack portalSubscriptionsGridItemUpgradePage">
                            <div class="portalSubscriptionsGridItemUpgradePackTitle">Choose your pack size:</div>
                            <form class="portalSubscriptionsGridItemUpgradePackList">${upgradeEligibleHTML}</form>
                            <button class="portalSubscriptionsGridItemUpgradePackSubmit">${upgradeEligiblePackNextButton}</button>
                            <div class="portalSubscriptionsGridItemUpgradePackWarning">*No subscription necessary. This is a one-time add on.</div>
                            ${backHTML}
                        </div>
                        <div class="portalSubscriptionsGridItemUpgradeDate portalSubscriptionsGridItemUpgradePage">
                            <div class="portalSubscriptionsGridItemUpgradeDateTitle">When would you<br> like it to ship?</div>
                            <button class="portalSubscriptionsGridItemUpgradeDateNow">Ship Now</button>
                            <a class="portalSubscriptionsGridItemUpgradeDateCalendar" href="#">
                                <u>or choose</u> order date:
                                <svg width="42" height="35" viewBox="0 0 42 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="41.228" height="34.6219" fill="#153BFE"/>
                                    <line y1="6.54102" x2="41.228" y2="6.54102" stroke="white"/>
                                    <line y1="15.9316" x2="41.228" y2="15.9316" stroke="white"/>
                                    <line y1="25.3193" x2="41.228" y2="25.3193" stroke="white"/>
                                    <path d="M9.92188 34.6221L9.92187 7.04192" stroke="white"/>
                                    <path d="M21.125 34.6221L21.125 7.04192" stroke="white"/>
                                    <path d="M31.8047 34.6221L31.8047 7.04192" stroke="white"/>
                                </svg>
                            </a>
                            ${backHTML}
                        </div>
                        <div class="portalSubscriptionsGridItemUpgradeCalendar portalSubscriptionsGridItemUpgradePage">
                            <div class="portalSubscriptionsGridItemUpgradeCalendarTitle">When would you<br> like it to ship?</div>
                            <div class="portalSubscriptionsGridItemUpgradeCalendarDiv">
                                <input class="portalSubscriptionsGridItemUpgradeCalendarDivInput"> 
                            </div>
                            ${backHTML}
                        </div>
                    </div>
                `;
            }

            // upcoming
            function upcomingHTML() {
                // add a line about a discount if they are eligible
                let discountCopy = "";
                if (isUpgradeDiscountEligible === true) {
                    discountCopy = `
                        A ${price(firstTimeUpgradeDiscountAmount)} discount will be applied to your tissues.
                        <br><br>
                    `;
                }

                // upgrade pending is a upcoming one-time merge of 16->16+4 or 32->32+8
                if (upgradePending) {
                    const upgradeProduct = products[upgradePending.upgrade_variant_id];

                    // determine how many boxes of tissues they are getting
                    let tissueCount;
                    if (upgradeProduct.handle === "16-rolls-4-boxes" || upgradeProduct.handle === "16-rolls-4-boxes-ca") {
                        tissueCount = 4;
                    } else if (upgradeProduct.handle === "32-rolls-8-boxes" || upgradeProduct.handle === "32-rolls-8-boxes-ca") {
                        tissueCount = 8;
                    }

                    // format is slightly different
                    if (upgradeJustCompleted) {
                        return `
                            <div class="portalSubscriptionsGridItemUpcoming">
                                <div class="portalSubscriptionsGridItemUpcomingTitle"><u>${tissueCount} boxes of tissues</u> will ship with your next order.</div>
                                <div class="portalSubscriptionsGridItemUpcomingBody">
                                    ${discountCopy}
                                    You can adjust your order date above in your subscription panel.
                                </div>
                                <a class="portalSubscriptionsGridItemUpcomingCancel" href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"> <path d="M0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM12 4V3.5L1 3.5V4V4.5L12 4.5V4Z" fill="black"/> </svg>
                                    Cancel
                                </a>
                            </div>
                        `;
                    }

                    return `
                        <div class="portalSubscriptionsGridItemUpcoming">
                            <div class="portalSubscriptionsGridItemUpcomingBody">
                                Your next shipment will include ${tissueCount} boxes of tissues along with your TP and will ship on ${dateToString(subscription.next_charge_scheduled_at)}.
                                <br><br>
                                ${discountCopy}
                                This is a one-time add on; tissues will not recur on your subscription.
                            </div>
                            <a class="portalSubscriptionsGridItemUpcomingCancel" href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"> <path d="M0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM12 4V3.5L1 3.5V4V4.5L12 4.5V4Z" fill="black"/> </svg>
                                Cancel
                            </a>
                        </div>
                    `;
                }

                // a one-time order is a separate 12 pack tissue order
                if (onetime) {
                    return `
                        <div class="portalSubscriptionsGridItemUpcoming">
                            <div class="portalSubscriptionsGridItemUpcomingTitle">You’re all set.</div>
                            <div class="portalSubscriptionsGridItemUpcomingBody">
                                12 boxes of tissues will ship on ${dateToString(onetime.next_charge_scheduled_at)}.
                                <br><br>
                                This is a one-time add on; tissues will not recur on your subscription.
                            </div>
                            <a class="portalSubscriptionsGridItemUpcomingCancel" href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"> <path d="M0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM12 4V3.5L1 3.5V4V4.5L12 4.5V4Z" fill="black"/> </svg>
                                Cancel
                            </a>
                        </div>
                    `;
                }

                // if it's a 16+4 or 32+8, allow to downgrade/cancel
                if (upgradeJustCompleted && ["16-rolls-4-boxes", "32-rolls-8-boxes", "16-rolls-4-boxes-ca", "32-rolls-8-boxes-ca"].includes(product.handle)) {
                    // determine how many boxes of tissues they are getting
                    let tissueCount;
                    if (product.handle === "16-rolls-4-boxes" || product.handle === "16-rolls-4-boxes-ca") {
                        tissueCount = 4;
                    } else if (product.handle === "32-rolls-8-boxes" || product.handle === "32-rolls-8-boxes-ca") {
                        tissueCount = 8;
                    }

                    return `
                        <div class="portalSubscriptionsGridItemUpcoming">
                            <div class="portalSubscriptionsGridItemUpcomingTitle"><u>${tissueCount} boxes of tissues</u> will ship with your next order.</div>
                            <div class="portalSubscriptionsGridItemUpcomingBody">
                                ${discountCopy}
                                You can adjust your order date above in your subscription panel.
                            </div>
                            <a class="portalSubscriptionsGridItemUpcomingCancel" href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"> <path d="M0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM12 4V3.5L1 3.5V4V4.5L12 4.5V4Z" fill="black"/> </svg>
                                Cancel
                            </a>
                        </div>
                    `;
                }

                return "";
            }

            // create the subscription HTML (only show active by default)
            let HTML = `
                <div class="portalSubscriptionsGridItem ${subscription.status === "active" ? "active" : ""}" data-id="${subscription.id}" data-status="${subscription.status}" data-currency="${subscription.presentment_currency}" data-upgrade-limbo="${upgradeLimbo}">
                    <div class="portalSubscriptionsGridItemManage">
                        <div class="portalSubscriptionsGridItemManageHeader">
                            <img class="portalSubscriptionsGridItemManageHeaderImage" src="${product.featured_image}">
                            <div class="portalSubscriptionsGridItemManageHeaderTitle">${subscription.quantity > 1 ? `${subscription.quantity} x ` : ""} ${product.title}</div>
                            <div class="portalSubscriptionsGridItemManageHeaderGeneral">
                                <div class="portalSubscriptionsGridItemManageHeaderGeneralCurrent">Delivered every <span class="portalSubscriptionsGridItemManageHeaderGeneralCurrentModify">${subscription.order_interval_frequency} ${subscription.order_interval_unit}${subscription.order_interval_frequency > 1 ? "s" : ""}</span></div>
                                <button class="portalSubscriptionsGridItemManageHeaderGeneralModify">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                    </svg>
                                    Modify Subscription
                                </button>
                            </div>
                            <div class="portalSubscriptionsGridItemManageHeaderUpdated">
                                <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                </svg>
                                Subscription Updated
                            </div>
                        </div>
                        <div class="portalSubscriptionsGridItemManageBody">
                            <div class="portalSubscriptionsGridItemManageBodyModify">
                                <div class="portalSubscriptionsGridItemManageBodyModifyTitle">Modify your subscription:</div>
                                <div class="portalSubscriptionsGridItemManageBodyModifyForm">
                                    <select class="portalSubscriptionsGridItemManageBodyModifyFormVariant">${planHTML()}</select>
                                    <select class="portalSubscriptionsGridItemManageBodyModifyFormCadence">${cadenceHTML()}</select>
                                </div>
                                <div class="portalSubscriptionsGridItemManageBodyModifyActions">
                                    <button class="portalSubscriptionsGridItemManageBodyModifyActionsSave portalButton primary">Update Subscription</button>
                                    <button class="portalSubscriptionsGridItemManageBodyModifyActionsCancel">No thanks, leave as-is</button>
                                </div>
                                <button class="portalSubscriptionsGridItemManageBodyModifyExit">
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Group 876">
                                            <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                            <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                            <div class="portalSubscriptionsGridItemManageBodyResume ${subscription.status === "cancelled" ? "active" : ""}">
                                <div class="portalSubscriptionsGridItemManageBodyResumeLabel portalButton">Inactive</div>
                                <button class="portalSubscriptionsGridItemManageBodyResumeNow portalButton">Re-activate</button>
                            </div>
                            <div class="portalSubscriptionsGridItemManageBodyDelivery ${subscription.status === "active" ? "active" : ""}">
                                <div class="portalSubscriptionsGridItemManageBodyDeliveryTitle">
                                    Next Order Date:
                                    <div class="portalSubscriptionsGridItemManageBodyDeliveryTitleUpdated">
                                        <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                        </svg>
                                        Order Date Updated
                                    </div> 
                                </div>
                                <div class="portalSubscriptionsGridItemManageBodyDeliveryDate">${nextDeliveryDateHTML()}</div>
                                <button class="portalSubscriptionsGridItemManageBodyDeliveryModify">
                                    or choose next order date:
                                    <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Group 853">
                                            <rect id="Rectangle 35" width="30.5108" height="25.622" fill="#414141" fill-opacity="0.23"/>
                                            <line id="Line 87" y1="4.71045" x2="30.5108" y2="4.71045" stroke="white"/>
                                            <line id="Line 91" y1="11.6602" x2="30.5108" y2="11.6602" stroke="white"/>
                                            <line id="Line 92" y1="18.6074" x2="30.5108" y2="18.6074" stroke="white"/>
                                            <path id="Line 88" d="M7.34375 25.6221L7.34375 5.21136" stroke="white"/>
                                            <path id="Line 89" d="M15.6367 25.6221L15.6367 5.21136" stroke="white"/>
                                            <path id="Line 90" d="M23.5391 25.6221L23.5391 5.21136" stroke="white"/>
                                        </g>
                                    </svg>
                                </button>
                                <div class="portalSubscriptionsGridItemManageBodyDeliveryReschedule">
                                    <button class="portalSubscriptionsGridItemManageBodyDeliveryRescheduleNow portalButton primary">Ship my order now</button>
                                    <button class="portalSubscriptionsGridItemManageBodyDeliveryRescheduleWeek portalButton">Push back 1 week</button>
                                    <button class="portalSubscriptionsGridItemManageBodyDeliveryRescheduleMonth portalButton">Push back 1 month</button>
                                </div>
                            </div>
                            <div class="portalSubscriptionsGridItemManageBodyAddress">
                                <div class="portalSubscriptionsGridItemManageBodyAddressCurrent active">                        
                                    <div class="portalSubscriptionsGridItemManageBodyAddressCurrentLabel">
                                        Delivered to:
                                        <div class="portalSubscriptionsGridItemManageBodyAddressCurrentLabelUpdated">
                                            <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                            </svg>
                                            Address Updated
                                        </div>
                                    </div>
                                    <div class="portalSubscriptionsGridItemManageBodyAddressCurrentName">
                                        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"/>
                                        </svg>
                                        ${address.address1}
                                    </div>
                                    <button class="portalSubscriptionsGridItemManageBodyAddressCurrentModify">
                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                        </svg>
                                        Change Address
                                    </button>
                                </div>
                                <div class="portalSubscriptionsGridItemManageBodyAddressEdit">
                                    <div class="portalSubscriptionsGridItemManageBodyAddressEditLabel">Modify address:</div>
                                    <select class="portalSubscriptionsGridItemManageBodyAddressEditSelect">
                                        ${addressHTML()}
                                        <option value="new">Add a new address</option>
                                    </select>
                                    <form class="portalSubscriptionsGridItemManageBodyAddressEditForm">
                                        <input type="text" name="first_name" placeholder="First Name" aria-label="First Name" required>
                                        <input type="text" name="last_name" placeholder="Last Name" aria-label="Last Name" required>
                                        <input type="text" name="address1" placeholder="Address Line 1" aria-label="Address Line 1" required>
                                        <input type="text" name="address2" placeholder="Address Line 2" aria-label="Address Line 2">
                                        <input type="text" name="city" placeholder="City" aria-label="City" required>
                                        <input type="text" name="province" placeholder="State" aria-label="State" required>
                                        <input type="text" name="zip" placeholder="ZIP code" aria-label="ZIP code" required>
                                        <select name="country_code" aria-label="Country Code" required">
                                            <option selected disabled>Country</option>
                                            <option value="US">United States</option>
                                            <option value="CA">Canada</option>
                                        </select>
                                        <input type="tel" name="phone" placeholder="Phone number" aria-label="Phone number" required>
                                        <button class="portalSubscriptionsGridItemManageBodyAddressEditFormSave portalButton primary">Update Address</button>
                                        <button class="portalSubscriptionsGridItemManageBodyAddressEditFormCancel" type="button">No thanks, leave as-is</button>
                                        <button class="portalSubscriptionsGridItemManageBodyAddressEditFormExit" type="button">
                                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="Group 876">
                                                    <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                                    <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                                </g>
                                            </svg>
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <div class="portalSubscriptionsGridItemManageBodyPayment">
                                <div class="portalSubscriptionsGridItemManageBodyPaymentCurrent active">
                                    <div class="portalSubscriptionsGridItemManageBodyPaymentCurrentLabel">
                                        Payment method:
                                        <div class="portalSubscriptionsGridItemManageBodyPaymentCurrentLabelUpdated">
                                            <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                            </svg>
                                            Payment Updated
                                        </div>
                                    </div>
                                    <div class="portalSubscriptionsGridItemManageBodyPaymentCurrentName">
                                        <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Group 873">
                                                <rect id="Rectangle 1905" width="28" height="17" rx="2" fill="#D9D9D9" fill-opacity="0.47"/>
                                                <rect id="Rectangle 1906" y="4" width="28" height="3" fill="#D9D9D9"/>
                                            </g>
                                        </svg>
                                        **** **** **** **** ${paymentMethod.payment_details.last4}
                                    </div>
                                    <button class="portalSubscriptionsGridItemManageBodyPaymentCurrentModify">
                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                        </svg>
                                        Edit Payment
                                    </button>
                                </div>
                                <div class="portalSubscriptionsGridItemManageBodyPaymentEdit">
                                    <div class="portalSubscriptionsGridItemManageBodyPaymentEditLabel">Modify payment method:</div>
                                    <form class="portalSubscriptionsGridItemManageBodyPaymentEditForm">
                                        <input type="number" name="cc_number" placeholder="Credit Card Number" aria-label="Credit Card Number" required>
                                        <select name="cc_exp_month" aria-label="Expiration Month" required>
                                            <option selected disabled value="">Expiration Month</option>
                                            <option value="01">Jan (01)</option>
                                            <option value="02">Feb (02)</option>
                                            <option value="03">Mar (03)</option>
                                            <option value="04">Apr (04)</option>
                                            <option value="05">May (05)</option>
                                            <option value="06">Jun (06)</option>
                                            <option value="07">Jul (07)</option>
                                            <option value="08">Aug (08)</option>
                                            <option value="09">Sep (09)</option>
                                            <option value="10">Oct (10)</option>
                                            <option value="11">Nov (11)</option>
                                            <option value="12">Dec (12)</option>
                                        </select>
                                        <select name="cc_exp_year" aria-label="Expiration Year" required>
                                            <option selected disabled value="">Expiration Year</option>
                                            <option value="2023">2023</option>
                                            <option value="2024">2024</option>
                                            <option value="2025">2025</option>
                                            <option value="2026">2026</option>
                                            <option value="2027">2027</option>
                                            <option value="2028">2028</option>
                                            <option value="2029">2029</option>
                                            <option value="2030">2030</option>
                                            <option value="2031">2031</option>
                                            <option value="2032">2032</option>
                                            <option value="2033">2033</option>
                                            <option value="2034">2034</option>
                                            <option value="2035">2035</option>
                                            <option value="2036">2036</option>
                                            <option value="2037">2037</option>
                                            <option value="2038">2038</option>
                                            <option value="2039">2039</option>
                                            <option value="2040">2040</option>
                                        </select>
                                        <input type="number" name="cc_cvc" placeholder="CVC" aria-label="CVC" required>
                                        <button class="portalSubscriptionsGridItemManageBodyPaymentEditFormSave portalButton primary">Update Payment Method</button>
                                        <button class="portalSubscriptionsGridItemManageBodyPaymentEditFormCancel" type="button">No thanks, leave as-is</button>
                                        <button class="portalSubscriptionsGridItemManageBodyPaymentEditFormExit" type="button">
                                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="Group 876">
                                                    <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                                    <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                                </g>
                                            </svg>
                                        </button>
                                    </form>                            
                                </div>
                            </div>
                        </div>
                    </div>
                    ${upgradeHTML()}
                    ${upcomingHTML()}
                </div> 
            `;

            // check if we have a target, if so replace the content, otherwise append
            if (target) {
                target.outerHTML = HTML;
            } else {
                document.querySelector("#portalSubscriptionsGrid").insertAdjacentHTML("beforeend", HTML);
            }

            // add event listeners, save item
            let item = document.querySelector(`.portalSubscriptionsGridItem[data-id="${subscription.id}"]`);

            /********* Functions *********/

            // function to close all open forms
            function closeAllForms() {
                // close actions
                item.querySelector(".portalSubscriptionsGridItemManageBodyModifyActionsCancel").click();

                // close address
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditFormCancel").click();

                // close payment
                item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEditFormCancel").click();
            }

            /******* Update Badge ********/

            // check if something was updated
            if (updated.includes("product")) {
                item.querySelector(".portalSubscriptionsGridItemManageHeaderUpdated").classList.add("active");
            }
            if (updated.includes("date")) {
                item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryTitleUpdated").classList.add("active");

                // add updated class to the delivery date to indicate it was changed
                document.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryDate").classList.add("updated");

                // remove the primary class from the Send Now button since they just changed the date
                item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryRescheduleNow").classList.remove("primary");
            }
            if (updated.includes("address")) {
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressCurrentLabelUpdated").classList.add("active");
            }
            if (updated.includes("payment")) {
                item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentCurrentLabelUpdated").classList.add("active");
            }

            /***** Header ******/

            // open modify subscription
            item.querySelectorAll(".portalSubscriptionsGridItemManageHeaderGeneralCurrentModify,.portalSubscriptionsGridItemManageHeaderGeneralModify").forEach(element => element.addEventListener("click", function () {
                // close all forms
                closeAllForms();

                // open form
                item.querySelector(".portalSubscriptionsGridItemManageBodyModify").classList.add("active");
            }));

            /****** Modify ******/

            // update subscription (rolls/frequency)
            item.querySelector(".portalSubscriptionsGridItemManageBodyModifyActionsSave").addEventListener("click", async function () {
                // list of updated items
                let updated = [];

                // get currently selected variant and cadence
                let variant = item.querySelector(".portalSubscriptionsGridItemManageBodyModifyFormVariant").value;
                let variantInt = parseInt(variant);
                let cadence = item.querySelector(".portalSubscriptionsGridItemManageBodyModifyFormCadence").value;

                // update object
                let updatePayload = {};

                // check if variant is different
                if (variantInt !== product.variant_id) {
                    // GA4 change variant
                    gtag('event', 'portal_change_variant');

                    updatePayload.use_external_variant_defaults = true;
                    updatePayload.external_variant_id = {
                        ecommerce: variant
                    };
                    updated.push("product");
                }

                // check if frequency is different
                if (parseInt(cadence) !== subscription.order_interval_frequency) {
                    // GA4 change cadence
                    gtag('event', 'portal_change_cadence');

                    updatePayload.order_interval_frequency = cadence;
                    updatePayload.charge_interval_frequency = cadence;
                    updatePayload.order_interval_unit = "week";
                    updated.push("date");
                }

                // no change
                if (Object.keys(updatePayload).length === 0) {
                    await Swal.fire({
                        "icon": "error",
                        "title": "No change detected to your subscription."
                    });
                    return;
                }

                // start loading
                this.classList.add("loading");

                // save old subscription
                let currentNextChargeDate = subscription.next_charge_scheduled_at;

                // update
                subscription = await recharge.subscription.updateSubscription(
                    session,
                    subscription.id,
                    updatePayload,
                    {commit: true}
                );

                // check if the next charge date changed
                if (currentNextChargeDate !== subscription.next_charge_scheduled_at) {
                    // ask the user if they want to update the next charge date to the old or new charge date since it changes when you change the frequency
                    let date = await openDeliveryModal(currentNextChargeDate, subscription.next_charge_scheduled_at);

                    // update the charge date if the date is different
                    if (date !== subscription.next_charge_scheduled_at) {
                        subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, date, {commit: true});
                    }
                }

                // refresh subscription pricing if the variant changed
                if (variantInt !== product.variant_id) {
                    await refreshSubscriptionPrice(subscription.id);
                }

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, updated);
            });

            // cancel modify subscription
            item.querySelectorAll(".portalSubscriptionsGridItemManageBodyModifyActionsCancel,.portalSubscriptionsGridItemManageBodyModifyExit").forEach(element => element.addEventListener("click", function () {
                // close modify container
                item.querySelector(".portalSubscriptionsGridItemManageBodyModify").classList.remove("active");

                // reset variant and cadence
                item.querySelector(".portalSubscriptionsGridItemManageBodyModifyFormVariant").value = product.variant_id;
                item.querySelector(".portalSubscriptionsGridItemManageBodyModifyFormCadence").value = subscription.order_interval_frequency;
            }));

            /****** Resume ******/

            // resume subscription
            item.querySelector(".portalSubscriptionsGridItemManageBodyResumeNow").addEventListener("click", async function () {
                // GA4 resume subscription
                gtag('event', 'portal_resume_subscription');

                // start loading
                this.classList.add("loading");

                subscription = await recharge.subscription.activateSubscription(session, subscription.id);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, []);

                // success
                await Swal.fire({
                    icon: "success",
                    title: "Your subscription has been reactivated."
                })
            });

            /****** Delivery ******/

            // choose a custom date - picker
            flatpickr(item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryModify"), {
                altFormat: "D, F j, Y",
                dateFormat: "Y-m-d",
                defaultDate: subscription.next_charge_scheduled_at,
                disableMobile: true,
                minDate: new Date().fp_incr(1)
            });

            // open date picker
            item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryDate").addEventListener("click", function () {
                item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryModify").click();
            });

            // choose a custom date event
            item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryModify").addEventListener("change", async function () {
                // GA4 change_shipment_date
                gtag('event', 'portal_change_shipment_date');

                // start loading
                this.classList.add("loading");

                // update subscription
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryModify").value);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            });

            // ship now
            item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryRescheduleNow").addEventListener("click", async function () {
                // GA4 ship now
                gtag('event', 'portal_ship_now');

                // start loading
                this.classList.add("loading");

                // update to today
                let newChargeDate = pushDate(new Date(), 1);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            })

            // push a week
            item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryRescheduleWeek").addEventListener("click", async function () {
                // GA4 push week
                gtag('event', 'portal_push_week');

                // start loading
                this.classList.add("loading");

                // update to 1 week
                let newChargeDate = pushDate(new Date(subscription.next_charge_scheduled_at), 7);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            })

            // push a month
            item.querySelector(".portalSubscriptionsGridItemManageBodyDeliveryRescheduleMonth").addEventListener("click", async function () {
                // GA4 push month
                gtag('event', 'portal_push_month');

                // start loading
                this.classList.add("loading");

                // push 30 days
                let newChargeDate = pushDate(new Date(subscription.next_charge_scheduled_at), 30);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            });

            /****** Address ******/

            // open address form
            item.querySelector(".portalSubscriptionsGridItemManageBodyAddressCurrentModify").addEventListener("click", function () {
                // close all forms
                closeAllForms();

                // open form
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressCurrent").classList.remove("active");
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEdit").classList.add("active");

                // prefill current
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditSelect").dispatchEvent(new Event("change"));
            });

            // change address
            item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditSelect").addEventListener("change", function () {
                // if it's a new address, we empty the form, otherwise we fill it
                if (this.value === "new") {
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm").reset();
                } else {
                    // get address
                    let address = addresses.find(address => address.id === parseInt(this.value));

                    // fill form
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='first_name']").value = address.first_name;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='last_name']").value = address.last_name;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='address1']").value = address.address1;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='address2']").value = address.address2 ?? "";
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='city']").value = address.city;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='province']").value = address.province;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='zip']").value = address.zip;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='country_code']").value = address.country_code;
                    item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm [name='phone']").value = address.phone;
                }
            });

            // update address submit
            item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditForm").addEventListener("submit", async function (e) {
                e.preventDefault();

                // GA4 update address
                gtag('event', 'portal_change_address');

                // save address info
                let form = Object.fromEntries(new FormData(this));

                // validate address
                if (form.address1.toLowerCase().includes('po box') || form.address1.includes('PO')) {
                    await Swal.fire({
                        icon: "error",
                        text: "We don't ship to PO Boxes at this time."
                    });
                    return;
                }

                // check if the countries are changing
                if (form.country_code !== address.country_code) {
                    await Swal.fire({
                        icon: "error",
                        text: "You cannot change your country. Please contact support info@plantpaper.us for more information."
                    });
                    return;
                }

                // get province
                const province = form.province.toLowerCase();

                // block short codes
                if (province.length <= 2) {
                    await Swal.fire({
                        icon: "error",
                        text: ` Please enter the full state/province name.`
                    });
                    return;
                }

                // check if province is on the ban list
                for (let i = 0; i < bannedProvinces.length; i++) {
                    if (province.includes(bannedProvinces[i])) {
                        await Swal.fire({
                            icon: "error",
                            text: `We can't ship to ${bannedProvinces[i]}. Please contact support info@plantpaper.us for more information.`
                        });
                        return;
                    }
                }


                // start loading
                this.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditFormSave").classList.add("loading");

                // address from data
                let addressForm = Object.fromEntries(new FormData(this));

                // check if we're adding a new address
                if (item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEditSelect").value === "new") {
                    // assign payment method to new address
                    addressForm.payment_method_id = paymentMethod.id;

                    // create new address
                    let updatedAddress = await recharge.address.createAddress(session, addressForm);

                    // attach address to subscription
                    subscription = await recharge.subscription.updateSubscriptionAddress(session, subscription.id, updatedAddress.id);
                } else {
                    await recharge.address.updateAddress(session, address.id, addressForm);
                }

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, ["address"]);
            });

            // cancel update (close form)
            item.querySelectorAll(".portalSubscriptionsGridItemManageBodyAddressEditFormCancel,.portalSubscriptionsGridItemManageBodyAddressEditFormExit").forEach(element => element.addEventListener("click", function () {
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressCurrent").classList.add("active");
                item.querySelector(".portalSubscriptionsGridItemManageBodyAddressEdit").classList.remove("active");
            }));

            /****** Payment ******/

            // toggle open/close modify payment
            item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentCurrentModify").addEventListener("click", async function () {
                // check what processor type
                if (paymentMethod.processor_name === "stripe") {
                    // close all forms
                    closeAllForms();

                    // open stripe payment form
                    item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentCurrent").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEdit").classList.add("active");
                } else if (paymentMethod.processor_name === "shopify_payments" && paymentMethod.payment_type === "SHOP_PAY") {
                    // show loading
                    Swal.fire({
                        title: 'Please Wait',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();

                    // send request
                    let formData = new FormData();
                    formData.set("paymentMethodID", paymentMethod.processor_payment_method_token);
                    let response = await fetch(`${root}/portal/update-payment-shop.php`, {
                        method: "POST",
                        body: formData
                    })
                        .then(data => data.json());

                    // check for error
                    if (response.error) {
                        await Swal.fire({
                            icon: "error",
                            title: response.error
                        });
                        return;
                    }

                    // close loading
                    Swal.close();

                    // redirect to url
                    window.location.href = response.url;
                } else if (paymentMethod.processor_name === "shopify_payments") {
                    // show loading
                    Swal.fire({
                        title: 'Please Wait',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();

                    // send request
                    let formData = new FormData();
                    formData.set("paymentMethodID", paymentMethod.processor_payment_method_token);
                    let response = await fetch(`${root}/portal/update-payment-shopify.php`, {
                        method: "POST",
                        body: formData
                    })
                        .then(data => data.json());

                    // check for error
                    if (response.error) {
                        await Swal.fire({
                            icon: "error",
                            title: response.error
                        });
                        return;
                    }

                    await Swal.fire({
                        title: "For security reasons, please check your email to update your payment method."
                    });
                } else {
                    await Swal.fire({
                        "icon": "error",
                        "title": "Please contact support with error P2."
                    });
                }
            });

            // update payment
            item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEditForm").addEventListener("submit", async function (e) {
                e.preventDefault();

                // start loading
                this.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEditFormSave").classList.add("loading");

                // send request
                let formData = new FormData(this);
                formData.set("recharge_customer_id", session.customerId)
                formData.set("stripe_customer_id", paymentMethod.processor_customer_token);
                formData.set("recharge_address_id", address.id);
                let response = await fetch(`${root}/portal/update-payment-stripe.php`, {
                    method: "POST",
                    body: formData
                })
                    .then(data => data.json());

                // stop loading
                this.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEditFormSave").classList.remove("loading");

                // check for error
                if (response.error) {
                    await Swal.fire({
                        icon: "error",
                        title: response.error
                    });
                    return;
                }

                // render subscription
                await renderSubscription(item, true, ["payment"]);
            });

            // cancel update
            item.querySelectorAll(".portalSubscriptionsGridItemManageBodyPaymentEditFormCancel,.portalSubscriptionsGridItemManageBodyPaymentEditFormExit").forEach(element => element.addEventListener("click", function () {
                // close the form
                item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentCurrent").classList.add("active");
                item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEdit").classList.remove("active");

                // reset form
                item.querySelector(".portalSubscriptionsGridItemManageBodyPaymentEditForm").reset();
            }));

            /****** Upgrade *******/

            // upgrades are not rendered for all products
            if (item.querySelector(".portalSubscriptionsGridItemUpgrade")) {
                // track the number of times the form is shown, only run 1 per session
                if (sessionStorage.getItem("triggered_upgrade_upsell_v1") !== "true") {
                    gtag('event', `portal_upsell_v1_shown`, {
                        discount_eligible: isUpgradeDiscountEligible,
                    });
                    sessionStorage.setItem("triggered_upgrade_upsell_v1", "true");
                }

                // upgrade start
                item.querySelector(".portalSubscriptionsGridItemUpgradeStartButton").addEventListener("click", function () {
                    // go to next page
                    item.querySelector(".portalSubscriptionsGridItemUpgradeStart").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemUpgradeType").classList.add("active");

                    // track the number of times the form is started
                    gtag('event', `portal_upsell_v1_started`, {
                        discount_eligible: isUpgradeDiscountEligible,
                    });
                });

                // upgrade type - subscribe/one-time purchase
                let upgradeType = null;
                item.querySelectorAll(".portalSubscriptionsGridItemUpgradeTypeSub, .portalSubscriptionsGridItemUpgradeTypeOTP").forEach(element => element.addEventListener("click", function () {
                    // determine which type of upgrade we are doing
                    upgradeType = this.classList.contains("portalSubscriptionsGridItemUpgradeTypeSub") ? "sub" : "otp";

                    // track submission
                    gtag('event', `portal_upsell_v1_selected_type`, {
                        discount_eligible: isUpgradeDiscountEligible,
                        type: upgradeType
                    });

                    // update warning
                    if (upgradeType === "sub") {
                        item.querySelector(".portalSubscriptionsGridItemUpgradePackWarning").textContent = ``;
                    } else {
                        item.querySelector(".portalSubscriptionsGridItemUpgradePackWarning").textContent = `*No subscription necessary. This is a one-time add on.`
                    }

                    // go to next page
                    item.querySelector(".portalSubscriptionsGridItemUpgradeType").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemUpgradePack").classList.add("active");
                }));

                // pack size next
                let upgradeProductID = null;
                let upgradeVariantID = null;
                item.querySelector(".portalSubscriptionsGridItemUpgradePackSubmit").addEventListener("click", async function () {
                    // save name
                    upgradeProductID = parseInt(item.querySelector(".portalSubscriptionsGridItemUpgradePackListItemRadio:checked").dataset.product);
                    upgradeVariantID = parseInt(item.querySelector(".portalSubscriptionsGridItemUpgradePackListItemRadio:checked").dataset.variant);

                    // check for no value
                    if (!upgradeVariantID) {
                        return;
                    }

                    // get the product
                    const product = products[upgradeVariantID];

                    // track submission
                    gtag('event', `portal_upsell_v1_selected_product`, {
                        discount_eligible: isUpgradeDiscountEligible,
                        type: upgradeType,
                        product: product.handle,
                    });

                    // if they  selected a one-time 16+4 or 32+8, we upgrade now, and don't ask for their date
                    if ((product.handle.includes("16-rolls") || product.handle.includes("32-rolls"))) {
                        item.querySelector(".portalSubscriptionsGridItemUpgradePack").classList.remove("active");
                        await completeUpgrade();
                        return;
                    }

                    // go to next page so we can set the date
                    item.querySelector(".portalSubscriptionsGridItemUpgradePack").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemUpgradeDate").classList.add("active");
                });

                // date event - keep/ship now
                let upgradeChargeDate = null;
                item.querySelector(`.portalSubscriptionsGridItemUpgradeDateNow`).addEventListener("click", async function () {
                    // determine if we are shipping now or picking a date
                    upgradeChargeDate = pushDate(new Date(), 1);

                    // go to next page
                    item.querySelector(".portalSubscriptionsGridItemUpgradeDate").classList.remove("active");
                    await completeUpgrade();
                });

                // date event - pick date
                item.querySelector(".portalSubscriptionsGridItemUpgradeDateCalendar").addEventListener("click", async function (e) {
                    e.preventDefault();

                    // go to next page
                    item.querySelector(".portalSubscriptionsGridItemUpgradeDate").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemUpgradeCalendar").classList.add("active");
                });

                // upgrade calendar submit
                item.querySelector(".portalSubscriptionsGridItemUpgradeCalendarDivInput").addEventListener("change", async function () {
                    // update the next charge date
                    upgradeChargeDate = this.value;

                    // go to success page
                    item.querySelector(".portalSubscriptionsGridItemUpgradeCalendar").classList.remove("active");
                    await completeUpgrade();
                });

                // calender initalizer
                flatpickr(item.querySelector(".portalSubscriptionsGridItemUpgradeCalendarDivInput"), {
                    inline: true,
                    altFormat: "D, F j, Y",
                    dateFormat: "Y-m-d",
                    defaultDate: new Date().fp_incr(1),
                    disableMobile: true,
                    minDate: new Date().fp_incr(1)
                });

                // back button events
                item.querySelectorAll(".portalSubscriptionsGridItemUpgradePageBack").forEach(element => element.addEventListener("click", function (e) {
                    e.preventDefault();

                    // find root page
                    const rootPage = this.closest(".portalSubscriptionsGridItemUpgradePage");

                    // go to previous page
                    rootPage.classList.remove("active");
                    rootPage.previousElementSibling.classList.add("active");
                }));

                // complete upgrade
                async function completeUpgrade() {
                    // the success message is slightly different when they first completed the flow.
                    upgradeJustCompleted = true;

                    // at this point in time we have the following answers:
                    // upgradeType (sub/otp), upgradeProductID, upgradeVariantID, upgradeChargeDate(YYYY-MM-DD)

                    // start loading animation
                    Swal.fire({
                        title: 'Completing your request...',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();

                    // There are 4 different scenarios for upgrades
                    // 1) SUB 12 - We create a new subscription in real-time
                    // 2) SUB 16+4/32+8 - We upgrade the subscription in real-time
                    // 3) OTP 12 - We create a new Recharge OTP in real-time with a subscription id as a property to track this
                    // 4) OTP 16+4/32+8 - We send this to the server to queue (the date of this is tied to the subscription)

                    // get the product
                    const upgradeProduct = products[upgradeVariantID];

                    // track success
                    gtag('event', `portal_upsell_v1_success`, {
                        discount_eligible: isUpgradeDiscountEligible,
                        type: upgradeType,
                        product: upgradeProduct.handle,
                    });

                    // track who has completed the upgrade flow in Klaviyo
                    try {
                        // track
                        klaviyo.push(["track", "Portal Upsell Signed Up | MalterTech"]);
                    } catch (e) {

                    }

                    // 10 SUB 12 - for 12 boxes, we create a new subscription
                    if (upgradeType === "sub" && ["12-boxes", "12-boxes-ca"].includes(upgradeProduct.handle)) {
                        // create a new subscription for the 12 pack
                        const newSubscription = await recharge.subscription.createSubscription(session, {
                                address_id: address.id,
                                next_charge_scheduled_at: upgradeChargeDate,
                                charge_interval_frequency: 12,
                                order_interval_frequency: 12,
                                order_interval_unit: 'week',
                                quantity: 1,
                                external_variant_id: {
                                    ecommerce: `${upgradeVariantID}`
                                },
                                external_product_id: {
                                    ecommerce: `${upgradeProductID}`
                                }
                            },
                            {
                                commit: true
                            }
                        );

                        // refresh subscription pricing
                        await refreshSubscriptionPrice(newSubscription.id);

                        // add the discount code if eligible
                        if (isUpgradeDiscountEligible === true) {
                            try {
                                await recharge.address.applyDiscountToAddress(session, newSubscription.address_id, discountCode);
                            } catch (e) {
                                await logError(`E1 - ${newSubscription.id} - ${JSON.stringify(e)}`);
                            }
                        }

                        // success
                        await Swal.fire({
                            icon: "success",
                            title: "You're all set! We've processed your update successfully.",
                        });

                        // reload
                        window.location.reload();
                    }

                    // 2) SUB 16+4/32+8 - we upgrade the existing subscription
                    if (upgradeType === "sub" && ["16-rolls-4-boxes", "16-rolls-4-boxes-ca", "32-rolls-8-boxes", "32-rolls-8-boxes-ca"].includes(upgradeProduct.handle)) {
                        // update subscription product/charge date
                        await recharge.subscription.updateSubscription(
                            session,
                            subscription.id, {
                                external_variant_id: {
                                    ecommerce: `${upgradeVariantID}`
                                },
                            },
                            {
                                commit: true
                            }
                        );

                        // refresh subscription pricing
                        await refreshSubscriptionPrice(subscription.id);

                        // add the discount code if eligible
                        if (isUpgradeDiscountEligible === true) {
                            try {
                                await recharge.address.applyDiscountToAddress(session, subscription.address_id, discountCode);
                            } catch (e) {
                                await logError(`E2 - ${subscription.id} - ${JSON.stringify(e)}`);
                            }
                        }

                        // render subscription
                        await renderSubscription(item, true, []);
                    }

                    // 3) OTP 12 - for 12 boxes, we create a new one-time recharge product
                    if (upgradeType === "otp" && ["12-boxes", "12-boxes-ca"].includes(upgradeProduct.handle)) {
                        const newOnetime = await recharge.onetime.createOnetime(session, {
                            address_id: address.id,
                            next_charge_scheduled_at: upgradeChargeDate,
                            quantity: 1,
                            external_variant_id: {
                                ecommerce: `${upgradeVariantID}`
                            },
                            external_product_id: {
                                ecommerce: `${upgradeProductID}`
                            },
                            properties: [
                                {
                                    name: "_subscription_id",
                                    value: `${subscription.id}`
                                }
                            ]
                        });

                        // refresh onetime pricing
                        await refreshOnetimePrice(newOnetime.id);

                        // add the discount code if eligible
                        if (isUpgradeDiscountEligible === true) {
                            try {
                                await recharge.address.applyDiscountToAddress(session, newOnetime.address_id, discountCode);
                            } catch (e) {
                                await logError(`E3 - ${newOnetime.id} - ${JSON.stringify(e)}`);
                            }
                        }

                        // render subscription
                        await renderSubscription(item, true, []);
                    }

                    // 4) OTP 16+4/32+8 - we send this to the server to queue the OTP on their next renewal
                    if (upgradeType === "otp" && ["16-rolls-4-boxes", "16-rolls-4-boxes-ca", "32-rolls-8-boxes", "32-rolls-8-boxes-ca"].includes(upgradeProduct.handle)) {
                        // send to server to queue the OTP upgrade on their next renewal
                        const response = await fetch(`${root}/portal/upgrade/new.php`, {
                            method: "POST",
                            body: JSON.stringify({
                                shopify_customer_id: shopifyCustomerID,
                                subscription_id: subscription.id,
                                upgrade_type: upgradeType,
                                upgrade_product_id: upgradeProductID,
                                upgrade_variant_id: upgradeVariantID,
                            })
                        })
                            .then(response => response.json());

                        // check for error, exit if there is one
                        if (response.error) {
                            Swal.fire({
                                icon: "error",
                                title: response.error
                            });
                            return;
                        }

                        // render subscription
                        await renderSubscription(item, true, []);
                    }

                    // stop loading
                    Swal.close();
                }

            }

            /********* Upcoming Cancel **********/

            // event listener to cancel
            item.querySelector(".portalSubscriptionsGridItemUpcomingCancel")?.addEventListener("click", async function (e) {
                e.preventDefault();

                // start loading
                Swal.fire({
                    title: 'Cancelling...',
                    allowOutsideClick: () => !Swal.isLoading()
                });
                Swal.showLoading();

                // track cancellation
                gtag('event', `portal_upsell_v1_cancel`, {
                    discount_eligible: isUpgradeDiscountEligible,
                });

                // if upgrade is pending, we delete it
                if (upgradePending) {
                    // send delete request
                    await fetch(`${root}/portal/upgrade/delete.php`, {
                        method: "POST",
                        body: JSON.stringify({
                            upgrade_id: upgradePending.id,
                        })
                    })
                }
                // otherwise it must be a one-time so we delete it
                else if (onetime) {
                    // cancel onetime
                    await recharge.onetime.deleteOnetime(session, onetime.id);
                } else {
                    // downgrade matrix
                    const downgradeMatrix = {
                        "16-rolls-4-boxes": "16-rolls",
                        "32-rolls-8-boxes": "32-rolls",
                        "16-rolls-4-boxes-ca": "16-rolls-ca",
                        "32-rolls-8-boxes-ca": "32-rolls-ca",
                    }

                    // determine the downgraded product handle
                    const currentProductHandle = product.handle;
                    const downgradedProductHandle = downgradeMatrix[currentProductHandle];
                    const downgradedProduct = Object.values(products).find(p => p.handle === downgradedProductHandle);

                    // update subscription product/charge date
                    await recharge.subscription.updateSubscription(
                        session,
                        subscription.id, {
                            external_variant_id: {
                                ecommerce: `${downgradedProduct.variant_id}`
                            },
                        },
                        {
                            commit: true
                        }
                    );

                    // refresh subscription pricing
                    await refreshSubscriptionPrice(subscription.id);

                    // add the discount code if eligible
                    if (isUpgradeDiscountEligible === true) {
                        try {
                            await recharge.address.removeDiscountsFromAddress(session, subscription.address_id, discountCode);
                        } catch (e) {
                            await logError(`E4 - ${subscription.id} - ${JSON.stringify(e)}`);
                        }
                    }

                    // render subscription
                    await renderSubscription(item, true, []);
                }

                // stop loading
                Swal.close();

                // render subscription
                await renderSubscription(item, true, []);
            });

        }

        // initial render
        renderSubscription(null, false, []);
    });

    /********************* Referral *********************/

    // exit referrals
    document.querySelector("#portalReferralsExit").addEventListener("click", function (e) {
        document.querySelector("#portalSubscriptions").classList.add("active");
        document.querySelector("#portalReferrals").classList.remove("active");
    });

    // submit new referral
    document.querySelector("#portalReferralsNewForm").addEventListener("submit", async function (e) {
        e.preventDefault();

        // get form data
        const formData = new FormData(this);

        // add other required information
        formData.set("from_name", `${customer.first_name} ${customer.last_name}`);
        formData.set("from_email", customer.email);

        // start loading on button
        document.querySelector('#portalReferralsNewFormButton').classList.add('loading');

        // send form data
        const response = await fetch(`${root}/referrals/portal/new.php`, {
            method: 'POST',
            body: JSON.stringify(Object.fromEntries(formData)),
        })
            .then(response => response.json());

        // stop loading on button
        document.querySelector('#portalReferralsNewFormButton').classList.remove('loading');

        // check for error
        if (response.error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: response.error,
            })
            return;
        }

        // reset form
        this.reset();

        // show success message
        Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `Your referral has been sent to ${formData.get('to_email')} successfully!`,
        });

        await setupReferralHistory();
    })

    // setup referal histroy
    async function setupReferralHistory() {
        // get referral history
        const referrals = await fetch(`${root}/referrals/portal/get-history.php`, {
            method: "POST",
            body: JSON.stringify({
                email: customer.email,
                customer_id: parseInt(customer.external_customer_id.ecommerce)
            })
        })
            .then(response => response.json());

        // if there is an error, exit
        if (referrals.error) {
            return;
        }

        // generate html
        let sentHTML = "";
        let redeemedHTML = "";
        referrals.forEach(document => {
            // check if the referral hasn't been used yet
            if (document.to.discount_code_used === false) {
                sentHTML += `
                    <span>${document.to.name}</span>
                    <span>${mongoDateToHuman(document.created_at)}</span>                
                `;
            }
            // check if the referral hasn't been applied yet
            else if (document.from.applied_at.length === 0) {
                redeemedHTML += `
                    <span>${document.to.name}</span>
                    <span>$${document.from.available_credit_dollars} applied to next renewal</span>                
                `;
            }
            // otherwise the discount has been applied
            else {
                // create a list of dates html since there can be more than 1
                let datesHTML = "";
                document.from.applied_at.forEach(date => {
                    datesHTML += mongoDateToHuman(date);
                    datesHTML += `<br>`;
                });

                // add response
                redeemedHTML += `
                    <span>${document.to.name}</span>
                    <span>${datesHTML}</span>        
                `;
            }
        })

        // update html
        document.querySelector("#portalReferralsHistorySent").innerHTML = sentHTML;
        document.querySelector("#portalReferralsHistoryRedeemed").innerHTML = redeemedHTML;
    }

    // load initial referral history
    setupReferralHistory();

    /********* General Account Functions **********/

    // open referrals
    document.querySelectorAll(`#portalAccountReferrals, a[href="#referrals"]`).forEach(function (element) {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("#portalSubscriptions").classList.remove("active");
            document.querySelector("#portalReferrals").classList.add("active");

            // on mobile, scroll to referrals
            if (window.innerWidth <= 800) {
                document.querySelector("#portalReferrals").scrollIntoView();
            }
        });

        // auto click on referrals if we have a paramter
        if (urlParams.has("open_referrals")) {
            element.click();
        }
    });

    // see past orders
    document.querySelector("#portalAccountPastOrders").addEventListener("click", async function () {
        // GA4 view past orders
        gtag('event', 'portal_view_past_orders');

        // return date and time
        function getDateTime(date) {
            let dateObj = new Date(parseInt(date["$date"]["$numberLong"]));
            return `${dateObj.toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                }
            )}`;
        }

        // send request
        let formData = new FormData();
        formData.set("email", customer.email);
        formData.set("customerID", customer.external_customer_id.ecommerce);
        let response = await fetch(`${root}/portal/get-orders.php`, {
            method: "POST",
            body: formData
        })
            .then(response => response.json());

        // check for error
        if (response.error) {
            await Swal.fire({
                icon: "error",
                title: response.error
            });
            return;
        }

        // generate HTML
        let HTML = `
            <table border="1" style="border-collapse: collapse; width: 100%;">
                <tr>
                    <td><b>Order #</b></td>
                    <td><b>Order Date</b></td>
                    <td><b>Total Price</b></td>
                </tr>
        `;
        response.forEach(order => {
            HTML += `
                <tr>
                    <td><a href="${order.order_status_url}" target="_blank" style="text-decoration: underline">#${order.name}</a></td>
                    <td>${getDateTime(order.created_at)}</td>
                    <td>$${order.total_price}</td>
                </tr>
            `;
        })
        HTML += "</table>"

        // show popup
        await Swal.fire({
            "title": "Past Orders",
            "html": HTML,
            "customClass": {
                popup: "malterWide"
            }
        })

    });

    // show inactive subscriptions
    document.querySelector("#portalAccountInactiveSubscriptions").addEventListener("click", async function () {
        // check if we have any cancelled subscriptions
        if (subscriptions.filter(subscription => subscription.status === "cancelled").length === 0) {
            await Swal.fire({
                title: "You do not have any inactive subscriptions to cancel."
            });
            return;
        }

        // show label
        document.querySelector("#portalSubscriptionsGridCancelled").classList.toggle("active");

        // show all hidden subscriptions
        document.querySelectorAll(`.portalSubscriptionsGridItem[data-status="cancelled"]`).forEach(item => item.classList.toggle("active"));

        // smooth scroll
        document.querySelector("#portalSubscriptionsGridCancelled").scrollIntoView();

        // update label
        if (document.querySelector("#portalSubscriptionsGridCancelled").classList.contains("active")) {
            this.textContent = "Hide inactive subscriptions";
        } else {
            this.textContent = "Show inactive subscriptions";
        }
    });

    // show inactive subscriptions if there are no active subscriptions
    if (subscriptions.filter(subscription => subscription.status === "active").length === 0) {
        document.querySelector("#portalAccountInactiveSubscriptions").click();
    }

    // logout
    document.querySelector("#portalAccountLogout").addEventListener("click", logout);

    /********* Cancel Subscription **********/

    // cancel subscription open
    dialogPolyfill.registerDialog(document.querySelector("#cancel"));
    document.querySelectorAll(".portalAccountCancel").forEach(button => {
        button.addEventListener("click", async function () {
            // vwo event
            window.VWO = window.VWO || [];
            VWO.event = VWO.event || function () {
                VWO.push(["event"].concat([].slice.call(arguments)))
            };
            VWO.event("portalCancellationStarted");

            // GA4 cancel subscription
            gtag('event', 'portal_cancel_subscription');

            // open popup and pass the subscriptions as a parameter
            await initiateCancel();
        });
    });


    /****************** Reactivate **************/

    // register dialog
    dialogPolyfill.registerDialog(document.querySelector("#reactivate"));

    // there are two types of reactivation (one with a discount and one without)
    const discountReactivation = sessionStorage.getItem("reactivate") === "10";

    // show reactivation if
    // 1) has "reactivate" in session storage
    // 2) has not already been shown
    // 3) has cancelled subscriptions
    if (
        sessionStorage.getItem("reactivate") &&
        subscriptions.filter(subscription => subscription.status === "cancelled").length > 0
    ) {
        // update copy accordingly
        if (discountReactivation) {
            document.querySelector("#reactivateTitle").innerHTML = "Re-activate your<br> subscription for 10% off.";
            document.querySelector("#reactivateSubtitle").innerHTML = "Which subscription would<br> you like to re-activate?";
        } else {
            document.querySelector("#reactivateTitle").innerHTML = "Which subscription would<br> you like to re-activate?";
            document.querySelector("#reactivateSubtitle").remove()
        }

        // append new subscription options
        subscriptions.forEach(subscription => {
            // find address
            let address = addresses.find(address => address.id === subscription.address_id);

            // only show cancelled subscriptions
            if (subscription.status !== "cancelled") {
                return;
            }

            // cadence and price are only rendered if it's a discount reactivation
            function discountReactivationHTML() {
                if (discountReactivation) {
                    return `
                        <div class="reactivateSubscriptionsItemCadence">Every ${subscription.order_interval_frequency} weeks</div>
                        <div class="reactivateSubscriptionsItemPrice">
                            <span class="reactivateSubscriptionsItemPriceTitle">You'll save $${((subscription.price * 0.10).toFixed(2))}</span>
                            <span class="reactivateSubscriptionsItemPriceCompare">$${subscription.price}</span> 
                            <span class="reactivateSubscriptionsItemPriceRenewal">$${(subscription.price * 0.9).toFixed(2)}</span>
                        </div>
                    `;
                }
                return "";
            }

            // append
            document.querySelector("#reactivateSubscriptions").insertAdjacentHTML("beforeend", `
                <label class="reactivateSubscriptionsItem">
                    <input class="reactivateSubscriptionsItemCheckbox" name="cancel_subscription" type="checkbox" value="${subscription.id}">
                    <div class="reactivateSubscriptionsItemProduct">${subscription.product_title}</div>
                    <div class="reactivateSubscriptionsItemAddress">
                        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"></path> </svg>
                        ${address.address1}
                    </div>
                    ${discountReactivationHTML()}
                </label>
            `)
        });

        // show reactivation
        document.querySelector("#reactivate").showModal();

        // remove session storage
        sessionStorage.removeItem("reactivate");
    }

    // reactivate subscription
    document.querySelector("#reactivateConfirm").addEventListener("click", async function () {
        // get number of selected
        let selectedSubscriptions = document.querySelectorAll(".reactivateSubscriptionsItemCheckbox:checked");

        // check if one is selectedSubscriptions
        if (selectedSubscriptions.length === 0) {
            await Swal.fire({
                title: "Please select a subscription to reactivate.",
                target: "#reactivate"
            });
            return;
        }

        // change active page
        document.querySelector(".reactivatePage.active").classList.remove("active");
        document.querySelectorAll(".reactivatePage")[1].classList.add("active");
    });

    // reactivate - send now
    document.querySelector("#reactivateNow").addEventListener("click", function () {
        // trigger date picker event change since this default date is tomorrow
        document.querySelector("#reactivateCalendarInput").dispatchEvent(new Event("change"));
    });

    // reactivate - send later
    document.querySelector("#reactivateLater").addEventListener("click", function () {
        // change active page
        document.querySelector(".reactivatePage.active").classList.remove("active");
        document.querySelectorAll(".reactivatePage")[2].classList.add("active");
    });

    // reactivate date picker
    flatpickr(document.querySelector("#reactivateCalendarInput"), {
        inline: true,
        altFormat: "D, F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: new Date().fp_incr(1),
        disableMobile: true,
        minDate: new Date().fp_incr(1)
    });

    // on datepicker change, trigger reactivation
    document.querySelector("#reactivateCalendarInput").addEventListener("change", async function () {
        // close modal
        document.querySelector("#reactivate").close();

        // get number of selected
        let selectedSubscriptions = document.querySelectorAll(".reactivateSubscriptionsItemCheckbox:checked");

        // start loading
        Swal.fire({
            title: 'Please Wait',
            allowOutsideClick: () => !Swal.isLoading(),
        });
        Swal.showLoading();

        // loop over each subscription
        for (let i = 0; i < selectedSubscriptions.length; i++) {
            // parse subscription id
            const subscriptionID = parseInt(selectedSubscriptions[i].value);

            // activate subscription
            let subscription = await recharge.subscription.activateSubscription(session, subscriptionID, {commit: true});

            // update subscription billign date
            subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, this.value, {commit: true});

            // check if we need to apply the discount
            if (discountReactivation) {
                try {
                    await recharge.address.applyDiscountToAddress(session, subscription.address_id, 'REACTIVATE_10');
                } catch (e) {
                    await logError(`E5 - ${subscription.id} - ${JSON.stringify(e)}`);
                }
            }

        }

        // close modal
        document.querySelector("#reactivate").close();

        // track reactivation
        if (discountReactivation) {
            gtag('event', 'portal_reactivate_subscription_10');
        } else {
            gtag('event', 'portal_reactivate_subscription');
        }

        // success
        await Swal.fire({
            icon: "success",
            title: "Your subscription has been reactivated successfully.",
        });

        // refresh
        Swal.fire({
            title: 'Refreshing',
            allowOutsideClick: () => !Swal.isLoading()
        });
        Swal.showLoading();
        window.location.reload();
    });

    // back button on date picker
    document.querySelector("#reactivateBack").addEventListener("click", function () {
        // change active page
        document.querySelector(".reactivatePage.active").classList.remove("active");
        document.querySelectorAll(".reactivatePage")[1].classList.add("active");
    });

    // close modal backdrop
    document.querySelector("#reactivate").addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });

    // close modal buttons
    document.querySelectorAll("#reactivateCancel,#reactivateExit").forEach(element => element.addEventListener("click", function () {
        document.querySelector("#reactivate").close();
    }));

    /**************** Start Portal **********/

    // show portal
    document.querySelector("#loading").classList.remove("active");
    document.querySelector("#intro").classList.add("active");
    document.querySelector("#portal").classList.add("active");

    /***************** Smooth Scroll ******************/

    // scroll to upgrade if indicated in url
    if (urlParams.has("tissue_upgrade") && document.querySelector(".portalSubscriptionsGridItemUpgrade")) {
        document.querySelector(".portalSubscriptionsGridItemUpgrade").scrollIntoView({behavior: 'smooth'});
    }
}

setupPortal();


/**************************************************** Confirm Delivery Date Modal ****************************************************/

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#delivery"));

// prevent escape key from closing modal
document.querySelector("#delivery").addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        e.preventDefault();
    }
});

/**
 * This function is called AFTER a delivery date is updated from changing the frequency of a subscription.
 * We ask the customer which date they want to keep (old or new) and return it
 * Open delivery modal
 * @param {string} oldDate (YYYY-MM-DD)
 * @param {string} newDate (YYYY-MM-DD)
 * @returns The date the customer wants to keep (YYYY-MM-DD)
 */
async function openDeliveryModal(oldDate, newDate) {
    // set date values
    document.querySelector("#deliveryOptionsItemOldValue").value = oldDate;
    document.querySelector("#deliveryOptionsItemNewValue").value = newDate;

    // update date text
    document.querySelector("#deliveryOptionsItemNewDisplay").textContent = dateToString(newDate);

    // open modal
    document.querySelector("#delivery").showModal();

    // wait for customer to select a date
    await new Promise((resolve, reject) => {
        document.querySelector("#deliveryConfirm").addEventListener("click", resolve);
    });

    // close modal
    document.querySelector("#delivery").close();

    // return date
    return document.querySelector(".deliveryOptionsItemCheckbox:checked").value;
}